var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_12214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6.33693V20.4386C32 26.648 26.9161 31.6805 20.6442 31.6805H7.20828L6.88557 32V31.6805H6.4015C2.86759 31.6805 0 28.844 0 25.3436V11.2419C0 5.03246 5.08392 0 11.3558 0H25.5985C29.1341 0 32 2.83655 32 6.33693Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_269_12214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2841 13.9033V18.4168C13.2841 18.9201 13.6954 19.3281 14.2046 19.3281H26.0832C26.0832 22.8268 23.2181 25.6634 19.6841 25.6634H14.549C13.7406 25.6634 12.9655 25.9812 12.3937 26.5474L6.88574 32.0003V12.992C6.88574 12.9374 6.88574 12.8836 6.88741 12.829C6.97604 9.40556 9.80608 6.65674 13.2849 6.65674H25.1636C25.6719 6.65674 26.0841 7.06397 26.0841 7.56804V12.0815C26.0841 12.5848 25.6727 12.9928 25.1636 12.9928H14.2054C13.6971 12.9928 13.2849 13.4001 13.2849 13.9041L13.2841 13.9033Z",
    fill: "url(#paint0_linear_269_12214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.65 0C11.775 0 6.45602 2.16859 6.40251 12.51C6.40084 12.5646 6.40084 12.6184 6.40084 12.673V31.6813C2.86683 31.6813 0 28.8448 0 25.3444V11.2428C0 5.03329 5.08405 0 11.3553 0H17.65Z",
    fill: "url(#paint1_linear_269_12214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9998 6.33693V20.4386C31.9998 15.6164 29.2149 12.673 24.6785 12.673C25.1868 12.673 25.599 12.2658 25.599 11.7617V7.24823C25.599 6.74499 25.1877 6.33693 24.6785 6.33693H12.7998C9.32101 6.33693 6.49097 9.08574 6.40234 12.5091C6.45585 2.16859 11.7748 0 17.6498 0H25.599C29.1347 0 31.9998 2.83655 31.9998 6.33693Z",
    fill: "url(#paint2_linear_269_12214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9986 20.4385C31.9986 26.648 26.9145 31.6804 20.6433 31.6804H6.39941L11.9073 26.2275C12.4792 25.6613 13.2534 25.3435 14.0627 25.3435H19.1977C22.7317 25.3435 25.5969 22.5069 25.5969 19.0082H13.7182C13.2099 19.0082 12.7977 18.601 12.7977 18.0969V13.5834C12.7977 13.0802 13.2091 12.6721 13.7182 12.6721H24.6764C29.2128 12.6721 31.9977 15.6163 31.9977 20.4377L31.9986 20.4385Z",
    fill: "url(#paint3_linear_269_12214)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_12214",
    x1: 6.35652,
    y1: 12.8,
    x2: 27.6236,
    y2: 27.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_269_12214",
    x1: 8.84713,
    y1: 2.92181,
    x2: 8.64309,
    y2: 28.4028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2296F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#095FA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_269_12214",
    x1: 26.4576,
    y1: 16.2355,
    x2: 15.9215,
    y2: 4.34881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2296F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#095FA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_269_12214",
    x1: 17.5039,
    y1: 24.7782,
    x2: 27.3468,
    y2: 12.6266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2296F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#095FA4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_12214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_269_12214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a236f18a.svg";
export { ForwardRef as ReactComponent };